<div class="pdf-wrapper">
    <dsn-button-squared
        [label]="'Baixar'"
        [type]="'secondary'"
        [icon]="'fa-solid fa-download'"
        [disabled]="false"
        [matTooltip]="'Baixar PDF'"
        (click)="pdfService.printAgain()"
        style="position: fixed; top: 26px; right: 36px; z-index: 100"
        class="pdf-button-download"
        [disabled]="loading"
    ></dsn-button-squared>
    <div class="pdf-container">
        <div class="pdf-page">
            <header class="pdf-header">
                <app-report-header
                    [options]="report?.options"
                    [reportName]="report?.props?.name"
                    [company]="company"
                ></app-report-header>
            </header>
            <main class="pdf-content">
                @if (reportPreferenceService.viewBench) {
                    <section class="pdf-section">
                        <dsn-expand-collapse
                            [isExpanded]="true"
                            [customIcon]="'images/icons/benchmarking-icon.svg'"
                            [label]="'Benchmarking'"
                            [type]="'default'"
                            [style.display]="hasBenchmarking ? 'block' : 'none'"
                            [fontSize]="'small'"
                            [disabled]="true"
                        >
                            <app-report-beachmarking-section
                                [report]="report"
                                [company]="company"
                                [loading]="loading"
                                [pdfMode]="true"
                                [previewMode]="false"
                                [locked]="true"
                                (handleBenchmarkingDataLoaded)="
                                    onBenchmarkingDataLoaded($event)
                                "
                            ></app-report-beachmarking-section>
                            <div
                                fxLayout="row"
                                style="margin-left: 14px; padding-bottom: 16px"
                            >
                                <dsn-button-link
                                    [label]="'Recurso exclusivo do digital'"
                                    [type]="'default'"
                                    [icons]="[
                                        'fa-solid fa-lock',
                                        'fa-solid fa-external-link-alt'
                                    ]"
                                    [href]="pdfService.linkDigital"
                                ></dsn-button-link>
                            </div>
                        </dsn-expand-collapse>
                    </section>
                }
                @if (reportPreferenceService.viewPeformance) {
                    <section class="pdf-section">
                        <dsn-expand-collapse
                            [isExpanded]="true"
                            [customIcon]="'images/icons/performance-icon.svg'"
                            [label]="'Performance'"
                            [type]="'default'"
                            [fontSize]="'small'"
                            [disabled]="true"
                        >
                            @defer (when !loading) {
                                <app-report-performance
                                    [report]="report"
                                    [visualizations]="report?.visualizations"
                                    [options]="report?.options"
                                    [company]="company"
                                    [pdfMode]="true"
                                    [linkDigital]="pdfService.linkDigital"
                                ></app-report-performance>
                            }
                        </dsn-expand-collapse>
                    </section>
                }
                @if (
                    !reportPreferenceService.viewBench &&
                    !reportPreferenceService.viewPeformance
                ) {
                    <section class="pdf-section">
                        <app-report-pdf-index
                            [visualizations]="indexTables"
                        ></app-report-pdf-index>
                    </section>
                }
            </main>
            <footer class="pdf-footer">
                <app-report-pdf-footer
                    [linkDigital]="pdfService.linkDigital"
                    [type]="'full'"
                >
                </app-report-pdf-footer>
            </footer>
        </div>
        @for (page of pdfService.indexPages; track $index) {
            <div class="pdf-page">
                <main class="pdf-content">
                    <section class="pdf-section">
                        <app-report-pdf-index
                            [visualizations]="page.visualizations"
                        ></app-report-pdf-index>
                    </section>
                </main>
            </div>
        }
        @if (report?.hasBalance) {
            @for (page of tableBalancePages; track $index) {
                <div
                    class="pdf-page pdf-page--break"
                    [id]="$index === 0 ? 'VisualizationTableBalance' : ''"
                >
                    @if ($index === 0) {
                        <header class="pdf-header">
                            <app-report-toolbar
                                [report]="report"
                                [options]="report?.options"
                                [company]="company"
                                [loading]="loading"
                                [scenarios]="report?.scenarios"
                                [budgets]="report?.budgets"
                                [projections]="report?.projections"
                                [dropdowns]="{
                                    period: true,
                                    comparation: true
                                }"
                                [pdf]="true"
                                [linkDigital]="pdfService.linkDigital"
                            ></app-report-toolbar>
                        </header>
                    }
                    <main class="pdf-content">
                        <section class="pdf-section">
                            <app-table-balance
                                [company]="company"
                                [options]="report?.options"
                                [loading]="loading"
                                [pdf]="true"
                                [indexInterval]="page"
                            ></app-table-balance>
                        </section>
                    </main>
                </div>
            }
        }
        @for (page of tableDrePages; track $index) {
            <div
                class="pdf-page pdf-page--break"
                [id]="$index === 0 ? 'VisualizationTableDre' : ''"
            >
                @if ($index === 0 && !report?.hasBalance) {
                    <header class="pdf-header">
                        <app-report-toolbar
                            [report]="report"
                            [options]="report?.options"
                            [company]="company"
                            [loading]="loading"
                            [scenarios]="report?.scenarios"
                            [budgets]="report?.budgets"
                            [projections]="report?.projections"
                            [dropdowns]="{
                                period: true,
                                comparation: true
                            }"
                            [pdf]="true"
                            [linkDigital]="pdfService.linkDigital"
                        ></app-report-toolbar>
                    </header>
                }
                <main class="pdf-content">
                    <section class="pdf-section">
                        <div fxLayout="column" class="dre-table-wrapper">
                            <app-table-dre-complete
                                [loading]="loading"
                                [company]="company"
                                [options]="report?.options"
                                [pdf]="true"
                                [dates]="page.dates"
                                [indexInterval]="page.indexInterval"
                                [tabActive]="page.tabActive"
                            ></app-table-dre-complete>
                        </div>
                    </section>
                </main>
                @if (
                    report?.visualizations?.visualzations.length === 0 &&
                    $index === tableDrePages.length - 1
                ) {
                    <footer class="pdf-footer">
                        <app-report-pdf-footer
                            [linkDigital]="pdfService.linkDigital"
                            [type]="'full'"
                        >
                        </app-report-pdf-footer>
                    </footer>
                }
            </div>
        }
        @if (!loading) {
            @for (
                visualization of report?.visualizations?.visualzations;
                track $index;
                let visualizationIndex = $index
            ) {
                <div class="pdf-page pdf-page--break">
                    @if ($index === 0) {
                        <header class="pdf-header">
                            <app-report-toolbar
                                [report]="report"
                                [options]="report?.options"
                                [company]="company"
                                [loading]="loading"
                                [scenarios]="report?.scenarios"
                                [budgets]="report?.budgets"
                                [projections]="report?.projections"
                                [dropdowns]="{
                                    period: true,
                                    comparation: true
                                }"
                                [pdf]="true"
                                [linkDigital]="pdfService.linkDigital"
                            ></app-report-toolbar>
                        </header>
                    }
                    <main
                        class="pdf-content"
                        [id]="'Visualization' + visualization.props._id"
                    >
                        <div
                            fxLayout="column"
                            style="
                                border: var(--border-width-1) solid
                                    var(--color-border-light);
                                border-radius: var(--border-radius-8);
                                padding: var(--spacing-8);
                                gap: var(--spacing-8);
                            "
                        >
                            <section class="pdf-section">
                                <app-report-visualization
                                    [loading]="loading"
                                    [visualization]="visualization"
                                    [company]="company"
                                    [report]="report"
                                    class="report-visualization"
                                    [previewMode]="false"
                                    [pdf]="true"
                                    [linkDigital]="pdfService.linkDigital"
                                ></app-report-visualization>
                            </section>
                            @if (visualization.tableValues) {
                                <h4
                                    class="text-10-semi-bold color-text-primary"
                                >
                                    Valores
                                </h4>
                                @for (
                                    columnDates of pdfService
                                        .visualizationsTableValuesPages[
                                        visualization.props._id
                                    ][0];
                                    track $index
                                ) {
                                    <section class="pdf-section">
                                        <app-report-table-values-pdf
                                            [options]="report.options"
                                            [company]="company"
                                            [visualization]="visualization"
                                            [columnDates]="columnDates"
                                        ></app-report-table-values-pdf>
                                    </section>
                                }
                            }
                            @if (
                                pdfService.visualizationsTableValuesPages[
                                    visualization.props._id
                                ].length === 1
                            ) {
                                <section
                                    class="pdf-section pdf-section-about-visualization"
                                >
                                    <app-about-visualization
                                        [visualization]="visualization"
                                        [pdf]="true"
                                    ></app-about-visualization>
                                </section>
                            }
                            @if (visualization.note) {
                                <div class="divider"></div>
                                <section class="pdf-section">
                                    <div
                                        class="note-container"
                                        fxLayout="column"
                                    >
                                        <div
                                            fxLayout="row"
                                            fxLayoutAlign="start center"
                                            class="gap-4"
                                        >
                                            <span
                                                class="text-10-semi-bold color-text-primary"
                                            >
                                                Notas da Contabilidade
                                            </span>
                                        </div>
                                        <app-report-visualization-note
                                            [visualization]="visualization"
                                            [resetPadding]="true"
                                            [pdf]="true"
                                        ></app-report-visualization-note>
                                    </div>
                                </section>
                            }
                        </div>
                    </main>

                    @if (
                        pdfService.visualizationsTableValuesPages[
                            visualization.props._id
                        ].length === 1 &&
                        visualizationIndex ===
                            report?.visualizations?.visualzations.length - 1
                    ) {
                        <footer class="pdf-footer">
                            <app-report-pdf-footer
                                [linkDigital]="pdfService.linkDigital"
                                [type]="'full'"
                            >
                            </app-report-pdf-footer>
                        </footer>
                    }
                </div>
                @if (visualization.tableValues) {
                    @for (
                        tableValuesDates of pdfService.visualizationsTableValuesPages[
                            visualization.props._id
                        ].slice(1);
                        track $index
                    ) {
                        <div class="pdf-page pdf-page--break">
                            <main class="pdf-content">
                                <div
                                    fxLayout="column"
                                    style="
                                        border: var(--border-width-1) solid
                                            var(--color-border-light);
                                        border-radius: var(--border-radius-8);
                                        padding: var(--spacing-8);
                                        gap: var(--spacing-8);
                                    "
                                >
                                    <h1
                                        class="color-text-primary text-10-semi-bold"
                                    >
                                        {{ visualization.props.name }}
                                    </h1>
                                    <h4
                                        class="text-10-semi-bold color-text-primary"
                                    >
                                        Valores
                                    </h4>
                                    @for (
                                        columnDates of tableValuesDates;
                                        track $index
                                    ) {
                                        <section class="pdf-section">
                                            <app-report-table-values-pdf
                                                [options]="report.options"
                                                [company]="company"
                                                [visualization]="visualization"
                                                [columnDates]="columnDates"
                                            ></app-report-table-values-pdf>
                                        </section>
                                    }

                                    @if (
                                        $index ===
                                        pdfService
                                            .visualizationsTableValuesPages[
                                            visualization.props._id
                                        ].length -
                                            2
                                    ) {
                                        <section class="pdf-section">
                                            <app-about-visualization
                                                [visualization]="visualization"
                                                [pdf]="true"
                                            ></app-about-visualization>
                                        </section>
                                    }
                                </div>
                            </main>
                            @if (
                                pdfService.visualizationsTableValuesPages[
                                    visualization.props._id
                                ].length > 1 &&
                                $index === tableValuesDates.length - 1 &&
                                visualizationIndex ===
                                    report?.visualizations?.visualzations
                                        .length -
                                        1
                            ) {
                                <footer class="pdf-footer">
                                    <app-report-pdf-footer
                                        [linkDigital]="pdfService.linkDigital"
                                        [type]="'full'"
                                    >
                                    </app-report-pdf-footer>
                                </footer>
                            }
                        </div>
                    }
                }
            }
        }
    </div>
</div>
